import axios from "../api/axios";
import { RiArrowRightCircleLine, RiDeleteBin2Line } from "react-icons/ri";
import React, { useEffect, useState } from "react";
import { getRoute } from "../utils/routes";
import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";

function AddTicket() {
  const { user } = useAuth();
  const [clientes, setClientes] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [addtickect, setAddticket] = useState([]);
  const [formData, setFormData] = useState({
    abonado: "",
    nabonado: "",
    nombre: "",
    telefono: "",
    direccion: "",
    poblacion: "",
    tipoaveria: "",
    descripcion: "",
  });

  const eliminarTicket = async (id) => {
    try {
      await axios.delete(`/api/tickets/${id}`);
      // Actualiza la lista de tickets después de eliminar
      setAddticket((prev) => prev.filter((t) => t.id !== id));
    } catch (error) {
      console.error("Error al eliminar el ticket:", error);
    }
  };

  const fetchData = async () => {
    try {
      const res = await axios.get("/api/addtickets");
      setAddticket(res.data.AddTicket); // asegúrate que el backend devuelve 'tickets'
    } catch (error) {
      console.error("Error al obtener tickets:", error);
    }
  };

  const seleccionarCliente = (cliente) => {
    setFormData((prev) => ({
      ...prev,
      abonado: cliente.id,
      nombre: cliente.nombre,
      direccion: cliente.direccion,
      poblacion: cliente.poblacion,
    }));
    setBusqueda("");
    setClientes([]);
  };

  useEffect(() => {
    const fetchCliente = async () => {
      try {
        const res = await axios.get(`/api/addTickets/bCliente?q=${busqueda}`);
        setClientes(res.data.clientes || []); // fallback a array vacío
      } catch (error) {
        console.error("Error al buscar cliente:", error);
        setClientes([]); // en caso de error, evitar undefined
      }
    };
    fetchCliente();
    fetchData();
  }, [busqueda]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validación básica
    if (
      !formData.abonado ||
      !formData.nombre ||
      !formData.ncontacto ||
      !formData.telefono ||
      !formData.direccion ||
      !formData.poblacion ||
      !formData.tipoaveria ||
      !formData.descripcion
    ) {
      setErrorMessage("Por favor, completa todos los campos.");

      // Ocultar el mensaje después de 3 segundos
      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
      return;
    }

    try {
      const response = await axios.post(
        "/api/addTickets", // asegúrate que la ruta es correcta
        formData
      );

      if (response.status === 200) {
        setFormData({
          ncontacto: "",
          telefono: "",
          tipoaveria: "",
          descripcion: "",
        });
        setErrorMessage(""); // limpiar error
        fetchData(); // actualizar lista
      } else {
        setErrorMessage("Error al enviar el formulario.");
      }
    } catch (error) {
      setErrorMessage(
        error.response?.data?.message || "Error al enviar el formulario."
      );

      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
    }
  };

  return (
    <div className="grid grid-cols-4 gap-4 min-h-[calc(100vh-6rem)]">
      <form onSubmit={handleSubmit} className="col-span-3 bg-secondary-100">
        <h1 className="p-4 px-5 font-bold small-2xl uppercase">Tarea nueva</h1>

        <div className="grid grid-cols-12 px-4 text-xs font-bold uppercase mt-0.5">
          <div className="relative w-full col-span-12">
            <input
              type="text"
              className="w-full p-2 px-3 bg-secondary-900 rounded-lg"
              placeholder="Nombre / Nº Abonado..."
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
            />

            {/* Mostrar solo si hay texto en búsqueda y hay resultados */}
            {busqueda.length > 0 && clientes.length > 0 && (
              <ul className="absolute z-10 bg-secondary-900 rounded-lg mt-1 w-full max-h-60 overflow-y-auto shadow-lg">
                {clientes.map((cliente) => (
                  <li
                    key={cliente.id}
                    className="cursor-pointer hover:bg-secondary-700 p-2 text-xs font-bold uppercase"
                    onClick={() => seleccionarCliente(cliente)}
                  >
                    {cliente.id}: {cliente.nombre}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
        <div className="grid grid-cols-12 px-4 text-xs font-bold uppercase mt-2">
          <div className="col-span-1 me-3">
            <input
              id="abonado"
              type="text"
              value={formData.abonado}
              placeholder="Nº Abonado"
              className="w-full p-2 px-3 bg-secondary-900 rounded-lg"
            />
          </div>

          <div className="col-span-3 me-3">
            <input
              id="nombre"
              type="text"
              value={formData.nombre}
              placeholder="Nombre/Empresa"
              className="w-full p-2 px-3 bg-secondary-900 rounded-lg"
            />
          </div>

          <div className="col-span-4 me-3">
            <input
              id="ncontacto"
              type="text"
              value={formData.ncontacto}
              onChange={handleChange}
              placeholder="Nombre Contacto"
              className="w-full p-2 px-3 bg-secondary-900 rounded-lg"
            />
          </div>

          <div className="col-span-2 me-3">
            <input
              id="telefono"
              type="text"
              value={formData.telefono}
              onChange={handleChange}
              placeholder="Teléfono"
              className="w-full p-2 px-3 bg-secondary-900 rounded-lg"
            />
          </div>

          <div className="col-span-2">
            <select
              id="tipoaveria"
              value={formData.tipoaveria}
              onChange={handleChange}
              className="w-full p-2 px-3 bg-secondary-900 rounded-lg"
            >
              <option value="" disabled>
                Selecciona tipo
              </option>
              <option value="Baja Batería">Baja Batería</option>
              <option value="Avería Zona">Avería Zona</option>
              <option value="Fallo Comunicación">Fallo Comunicación</option>
              <option value="Fallo CCTV">Fallo CCTV</option>
              <option value="Otro">Otro</option>
            </select>
          </div>
        </div>
        <div className="grid grid-cols-12 px-4 text-xs font-bold uppercase mt-2">
          <div className="col-span-8 me-3">
            <input
              id="direccion"
              type="text"
              value={formData.direccion}
              placeholder="Direccion"
              className="w-full p-2 px-3 bg-secondary-900 rounded-lg"
            />
          </div>
          <div className="col-span-4">
            <input
              id="poblacion"
              type="text"
              value={formData.poblacion}
              placeholder="Direccion"
              className="w-full p-2 px-3 bg-secondary-900 rounded-lg"
            />
          </div>
        </div>
        <div className="grid grid-cols-12 px-4 text-xs font-bold uppercase mt-2">
          <div className="col-span-12">
            <textarea
              id="descripcion"
              value={formData.descripcion}
              onChange={handleChange}
              placeholder="Descripción"
              className="w-full p-2 px-3 bg-secondary-900 rounded-lg"
              rows={15}
            />
          </div>
        </div>

        {errorMessage && (
          <div className="bg-red-500 text-white p-2 rounded mb-4 text-sm font-semibold transition-opacity duration-300">
            {errorMessage}
          </div>
        )}

        <div className="flex justify-center items-center">
          <button
            type="submit"
            className="bg-secondary-900 min-w-md font-bold uppercase py-2 px-6 mt-4 text-sm rounded-lg hover:text-black transition-colors"
          >
            Enviar
          </button>
        </div>
      </form>

      {/* Sección de últimas averías */}
      <div className="col-span-1 bg-secondary-100 font-bold small-2xl uppercase h-[80vh] overflow-y-auto">
        <h1 className="p-4 px-4.5 font-bold small-2xl uppercase">
          Últimas Averías
        </h1>
        {addtickect.map((p) => (
          <div
            key={p.index}
            className="bg-secondary-900 p-4 ms-3 me-3 rounded-xl mb-3"
          >
            <h1 className="flex flex-row justify-between font-extrabold text-tiny uppercase mb-2">
              <div>
                <span>Nombre: </span>
                <span className="font-semibold text-tiny">{p.abonado}</span>
              </div>
              <div className="flex gap-2">
                <Link
                  to={getRoute(user, `editTicket/${p.id}`)}
                  className="flex items-center me-5"
                >
                  <RiArrowRightCircleLine size={20} />
                </Link>
                <button
                  onClick={() => eliminarTicket(p.id)}
                  className="flex items-center text-red-500 hover:text-red-700"
                >
                  <RiDeleteBin2Line size={20} />
                </button>
              </div>
            </h1>
            <h1 className="font-extrabold text-tiny uppercase mb-2">
              Nombre:&nbsp;&nbsp;
              <span className="font-semibold text-tiny">{p.nombre}</span>
            </h1>
            <h1 className="font-extrabold text-tiny uppercase mb-2">
              Dirección:{" "}
              <span className="font-semibold text-tiny">{p.direccion}</span>
            </h1>
            <h1 className="font-extrabold text-tiny uppercase mb-2">
              Población:{" "}
              <span className="font-semibold text-tiny">{p.poblacion}</span>
            </h1>
            <h1 className="font-extrabold text-tiny uppercase mb-2">
              Averia:{" "}
              <span className="font-semibold text-tiny">{p.tipoaveria}</span>
            </h1>
            <h1 className="font-extrabold text-tiny uppercase mb-2 overflow-hidden line-clamp-3">
              Descripcion:{" "}
              <span className="font-semibold text-tiny">
                {p.descripcion.length > 200
                  ? p.descripcion.slice(0, 50) + "..."
                  : p.descripcion}
              </span>
            </h1>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AddTicket;
